var map = {
	"./0.png": 8073,
	"./1.png": 1725,
	"./2.png": 4683,
	"./3.png": 6808,
	"./4.png": 1909,
	"./5.png": 2484,
	"./6.png": 7169,
	"./7.png": 2680,
	"./8.png": 3991
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7533;